import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import productRoutes from './product'
import mobileRoutes from './mobile'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...routes, ...productRoutes, ...mobileRoutes]
})

const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false
  return /Mobi|Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
}

const toMobilePath = (to) => {
  if (to.path.startsWith('/m')) return to.fullPath
  
  // 定义需要转换为移动端专用页面的路径（白名单）
  const mobileMappings = {
    '/': '/m',
    '/about': '/m/about',
    '/contact': '/m/contact',
    '/founder': '/m/founder',
    '/product/index': '/m/product',
	'/index': '/m/index',
  }
  
  // product/detail 特殊处理
  if (to.path === '/product/detail') {
    const id = to.query && (to.query.id || to.query.productId)
    return id ? `/m/product/${id}` : '/m/product'
  }
  
  // 其他所有路径（包括 /projects, /materials, /stories）保持原样，不重定向
  return mobileMappings[to.path] || to.fullPath
}

const toDesktopPath = (to) => {
  if (!to.path.startsWith('/m')) return to.fullPath
  
  const desktopMappings = {
    '/m': '/',
    '/m/about': '/about',
    '/m/contact': '/contact',
    '/m/founder': '/founder',
    '/index': '/index',
  }
  
  if (to.path.startsWith('/m/product/')) {
    return '/product/detail'
  }
  
  // 未知的 /m/xxx 路径，尝试去掉 /m 前缀后匹配（可选）
  if (desktopMappings[to.path]) {
    return desktopMappings[to.path]
  }
  // 兜底：如果匹配不到，返回原路径（避免死循环）
  return to.fullPath
}

router.beforeEach((to, from, next) => {
  const isMobile = isMobileDevice()
  
  // 移动端访问桌面路径（且不是 /m 开头）
  if (isMobile && !to.path.startsWith('/m')) {
    const target = toMobilePath(to)
    // 只有目标路径与当前路径不同时才重定向，防止死循环
    if (target !== to.fullPath) {
      next(target)
      return
    }
  }
  
  // 桌面端访问移动端路径（且以 /m 开头）
  if (!isMobile && to.path.startsWith('/m')) {
    const target = toDesktopPath(to)
    if (target !== to.fullPath) {
      next(target)
      return
    }
  }
  
  // 所有其他情况正常放行
  next()
})

export default router
